import React from 'react';
import { Link } from 'react-router-dom';

function Destinations() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Top Medical Cities in India: Elite Private Healthcare Destinations for Global Patients
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          Selecting the right urban destination is just as vital as choosing your surgical consultant. India's premier medical hub cities house massive clusters of ultra-modern, corporate multi-specialty hospitals optimized specifically for foreign passport holders. By mapping out clinical specialties, logistics profiles, and airport connectivity configurations across top destinations via independent informational directories like <strong>Medical Trip World</strong>, traveling families can coordinate their pre-planning steps with absolute confidence.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Treatment Cost Estimates & Location Checklists →
        </Link>
      </div>

      {/* SECTION 1: BREAKDOWN OF CITIES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Primary Private Medical Tourism Hubs
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '20px', fontSize: '0.95rem' }}>
          The major corporate clinical landscapes are concentrated across distinct metropolitan centers, each offering elite specialized ecosystems:
        </p>

        {/* CITY 1: DELHI NCR */}
        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px', marginBottom: '20px', borderLeft: '4px solid #0b3c5d', boxSizing: 'border-box' }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.2rem' }}>1. Delhi National Capital Region (NCR) – New Delhi, Gurgaon, Noida</h3>
          <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
            <strong>Primary Specialties:</strong> Advanced Cardiothoracic Surgery (CABG, Angioplasty), Robotic-Assisted Orthopedics, Heavy Oncology & Precision Bone Marrow Transplants.<br />
            <strong>Logistics Matrix:</strong> Served directly by Indira Gandhi International Airport (DEL). Gurgaon houses high-end serviced apartment rows engineered specifically for extended, limited-mobility outpatient recovery cycles.
          </p>
        </div>

        {/* CITY 2: MUMBAI */}
        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px', marginBottom: '20px', borderLeft: '4px solid #005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#005ba1', fontSize: '1.2rem' }}>2. Mumbai</h3>
          <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
            <strong>Primary Specialties:</strong> Specialized Pediatric Cardiology, Complex Neurosurgeries, Minimal-Access Gastrointestinal Interventions, Bariatric Care.<br />
            <strong>Logistics Matrix:</strong> Linked globally via Chhatrapati Shivaji Maharaj International Airport (BOM). Offers premier private luxury corporate accommodations alongside highly secure local transit options.
          </p>
        </div>

        {/* CITY 3: CHENNAI */}
        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px', marginBottom: '20px', borderLeft: '4px solid #ff9f1c', boxSizing: 'border-box' }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#ff9f1c', fontSize: '1.2rem' }}>3. Chennai</h3>
          <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
            <strong>Primary Specialties:</strong> Multi-Organ Transplants (Liver, Kidney, Heart), Advanced Ophthalmology, Micro-Invasive Spine Reconstructions.<br />
            <strong>Logistics Matrix:</strong> Connected by Chennai International Airport (MAA). Widely referenced as a highly cost-efficient private hub with highly standardized multi-lingual care assistance networks.
          </p>
        </div>
      </section>

      {/* SECTION 2: COMPARATIVE METRICS MATRIX - WRAPPED FOR MOBILE SAFETY */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Destination Decision Support Metrics
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          To streamline your evaluation paths, review this comparison of infrastructure indicators compiled from public corporate healthcare data profiles:
        </p>

        {/* Scroll Container Protection */}
        <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', border: '1px solid #e0e0e0', borderRadius: '4px', marginTop: '15px' }}>
          <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #ddd', background: '#fafafa' }}>
                <th style={{ padding: '12px 10px' }}>Destination City</th>
                <th style={{ padding: '12px 10px' }}>Core Clinical Strengths</th>
                <th style={{ padding: '12px 10px' }}>Airport Transit Time</th>
                <th style={{ padding: '12px 10px' }}>Outpatient Stay Options</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px 10px' }}><strong>Delhi NCR</strong></td>
                <td style={{ padding: '12px 10px' }}>Cardiology, Robotic Joints, Oncology</td>
                <td style={{ padding: '12px 10px' }}>15 - 30 Minutes</td>
                <td style={{ padding: '12px 10px' }}>Extensive (Premium Serviced Suites)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px 10px' }}><strong>Mumbai</strong></td>
                <td style={{ padding: '12px 10px' }}>Pediatric Heart, Neuro, Bariatric</td>
                <td style={{ padding: '12px 10px' }}>30 - 45 Minutes</td>
                <td style={{ padding: '12px 10px' }}>Moderate (Premium Boutique Hotels)</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px 10px' }}><strong>Chennai</strong></td>
                <td style={{ padding: '12px 10px' }}>Organ Transplants, Ophthalmology</td>
                <td style={{ padding: '12px 10px' }}>20 - 35 Minutes</td>
                <td style={{ padding: '12px 10px' }}>High (Budget/Mid-Range Guesthouses)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* SECTION 3: SAFETY & INDEPENDENT AUDITING CHECKPOINTS - FLEXIBLE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Vetting Local City Infrastructures Independently
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates strictly as an open informational venue and independent directory reference, we recommend that patients directly verify local infrastructure parameters with their selected facility before flying:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>Accreditation Data Verifications</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Ensure your selected facility inside your chosen target city holds active tracking credentials within the official Joint Commission International (JCI) public directory layout.
            </p>
          </div>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>Airport-to-Hospital Commute Security</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Confirm that the private hospital’s international helpdesk supplies pre-arranged transport options using climate-controlled vehicles to minimize physical strain upon landing.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e0e0e0', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem' }}>
          Frequently Asked Questions (FAQs) – Destination Cities Selection
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Which city is considered best for organ transplant options?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Chennai and Delhi NCR house exceptionally high concentrations of senior multi-organ transplant surgeons and specialized sterile ICUs. However, legal regulations require extensive sovereign committee verifications for any foreign transplant procedure.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Do all major medical cities provide language translation desks?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes, leading corporate private hospital networks in Delhi NCR, Mumbai, and Chennai maintain dedicated international teams fluent in English, Arabic, French, Russian, and Persian to guide families smoothly through treatment.
          </p>
        </div>
        
        <div style={{ marginBottom: '5px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Does Medical Trip World operate local transport vehicles or guest houses in these cities?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not provide logistics assets, manage local patient guest houses, or maintain formal corporate partnerships or Memorandums of Understanding (MOUs) with any private hospital system or hotel brand. All financial quotes, clinical diagnostics, and travel arrangements take place directly and exclusively between the patient and their self-selected healthcare provider.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <style>{`
            @media (max-width: 550px) {
              .footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
            }
          `}</style>
          <Link to="/submit-query" className="footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Destinations;